import type { IHandOfToHumanCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IHandoffToHumanChipData } from 'entities/TemplateActions/actions.tsx'
import { handoffToHuman } from 'widgets/TemplateActions/handoffToHuman'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { createHandOfToHumanCallingAction } from './createHandOfToHumanCallingAction.ts'

export const onHandoffToHumanChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: IHandoffToHumanChipData) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction } = store
    let action: IHandOfToHumanCallingActionPayload | undefined

    if ('token_id' in data) {
      const token_id = data.token_id
      const findAction = getAgentAction(token_id)

      if (token_id) {
        if (findAction?.action_type === 'hand_of_to_human') {
          action = findAction
        }
      }
    } else if (data) {
      action = createHandOfToHumanCallingAction(data)
    }
    if (action) {
      return handoffToHuman({
        onSave: (data) =>
          onUpdateAgentAction(createHandOfToHumanCallingAction(data, action.settings.token_id)),
        onDelete: () => deleteChipAndAgentAction(chip, action),
        data: action.settings,
      })
    }
  }
